module.exports = __webpack_public_path__ + "img/part1.3cc12387.png";